import Wow from 'wow.js'
import ProgressBar from 'progressbar.js'
import smoothscroll from 'smoothscroll-polyfill'
import header from '../_modules/header/index.js'
import {
    initSlider,
    initAccordion,
    revealLinksOnAction
} from '../_modules/helpers'
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle'
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking'

function init() {

    new Wow().init();
    smoothscroll.polyfill()

    const readMoreButton = document.querySelector('.l-6__more-btn')
    const moreSection = document.querySelector('.l-6__more')
    readMoreButton.addEventListener('click', () => {
        moreSection.classList.add('l-6__more--open')
        readMoreButton.remove()
    })

    header()
    sliderHandler()
    revealLinksOnAction(() => {
        handleRefsUs(REFS_US.SEO_US_PLAGIARISM)
        FirstTouchTracking()
    })
    plagiarismLogic()
    lasthopePopupLogic()
    runProgressBar()
    handleAccordion()
}


function getDomain() {
    var href = document.location.href;
    if (/dev/.test(href)) return 'https://' + document.location.host.split('.')[0] + '.studybay.local';
    return document.location.origin;
}

const handleAllAsOne = (allElements, cb) => allElements.forEach(one => cb(one))
const getValueFromOne = (allElements) => {
    for (const element of allElements) {
        const value = element.value
        if (value) return value
    }
    return ''
}

function sliderHandler() {
    const serviceSlider = document.getElementById('service-slider')
    const controls = serviceSlider.querySelector('.slider__controls')
    const inner = serviceSlider.querySelector('.l-3__info')

    let destroyer = null

    const init = () => {
        controls.hidden = false
        inner.classList.add('slider__inner')
        destroyer = initSlider(serviceSlider)
    }

    const reset = () => {
        if (destroyer) destroyer()
        controls.hidden = true
        inner.classList.remove('slider__inner')
    }

    const mql = window.matchMedia('(max-width: 768px)')
    if (mql.matches) init()
    else reset()

    if (mql.addListener) {
        mql.addListener((e) => e.matches ? init() : reset())
    } else {
        mql.addEventListener('change', (e) => e.matches ? init() : reset())
    }
}

function plagiarismLogic() {
    const PROGRESS_INTERVAL = 3000; // ms
    const TIME_TO_ASK_FOR_EMAIL = 10; // 30000 ms / PROGRESS_INTERVAL
    const barOptions = {
        color: '#142266',
        strokeWidth: 13,
        trailWidth: 13,
        easing: 'easeInOut',
        duration: 5000,
        text: {
            autoStyleContainer: false
        },
        from: { color: '#00c471', width: 13 },
        to: { color: '#00c471', width: 13 },
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);
            circle.path.setAttribute('stroke-width', state.width);

            var value = Math.round(circle.value() * 100);
            circle.setText(value +'%');
        }
    }

    const plagiarismContainer = document.querySelectorAll('.plagiarism');
    const plagiarismInput = document.querySelectorAll('.plagiarism__text');
    const plagiarismTextField = document.querySelectorAll('.plagiarism__text-field');
    const plagiarismFileField = document.querySelectorAll('.plagiarism__file-field');
    const filenameField = document.querySelectorAll('.file-name');
    const removeFile = document.querySelectorAll('.file-remove');
    const emailField = document.querySelectorAll('.plagiarism [type=email]');
    const resultControls = document.querySelectorAll('.plagiarism-result__nav');

    const lasthopePopupForm = document.querySelector("#lasthope-form");

    const messageContainer = document.querySelectorAll('.plagiarism .message-box');
    const messageField = document.querySelectorAll('.plagiarism .message-box__message');
    const messageClose = document.querySelectorAll('.plagiarism .message-box__close');

    const checkPlagiarismButton = document.querySelectorAll('.btn-plagiarism-check');
    const checkAnotherTextButton = document.querySelectorAll('.another-check-link');
    const sendEmailButton = document.querySelectorAll('.x3');
    const showTextButton = document.querySelectorAll('.x1');
    const showResultResultButton = document.querySelectorAll('.x2');
    const uploadFileButton = document.querySelectorAll('.btn-upload');

    const fileInput = document.querySelectorAll('.file-input');

    const textInfo = document.querySelectorAll('.plagiarism-result__info-text');
    const dataInfo = document.querySelectorAll('.plagiarism-result__info-data');
    const uniquenessCircle = document.querySelectorAll('.plagiarism-circle');
    const sourcesLinksContainer = document.querySelectorAll('.plagiarism-result__info-data-sources');
    const sourceLinks = document.querySelectorAll('.plagiarism-result__info-data-sources-list');
    const statisticsInfo = document.querySelectorAll('.plagiarism-result__statistics');
    const textLength = document.querySelectorAll('.text-length');
    const textLengthNoSpaces = document.querySelectorAll('.text-no-spaces-length');

    let file = null;
    let filename = '';
    let text = '';
    let title = '';
    let email = getValueFromOne(emailField);
    let checkRequestId = null;
    let progressCheckerId = null;
    let progressCounter = 0;

    const disableButton = (button) => {
        button.classList.add('btn--inactive')
        button.disabled = true
    }

    const enableButton = (button) => {
        button.classList.remove('btn--inactive')
        button.disabled = false
    }

    const setResult = (uniqueness) => window._uniquenessResultPercents = uniqueness

    const showLoader = () => {
        handleAllAsOne(plagiarismContainer, (element) => element.classList.add('plagiarism--load'))
    }

    const showEmailField = () => {
        handleAllAsOne(plagiarismContainer, (element) => {
            element.classList.remove('plagiarism--load')
            element.classList.add('plagiarism--long-load')
        })
    }

    const createSourceItem = (urlInfo) => {
        const item = document.createElement('li')
        item.className = 'plagiarism-result__info-data-sources-list-item'

        const unique = `<span>${(100 - urlInfo.unique)}%</span>`

        const uniqueWrapper = `<div class="plagiarism-result__info-data-sources-list-percent">${unique}</div>`

        const link = `<a href="${urlInfo.url}" class="plagiarism-result__info-data-sources-list-link cut" target="_blank">${urlInfo.url}</a>`

        item.insertAdjacentHTML('afterbegin', uniqueWrapper)
        item.insertAdjacentHTML('afterbegin', link)

        return item;
    }

    const showResult = (uniqueness, urls) => {
        var percentage = uniqueness / 100

        handleAllAsOne(textInfo, (element) => element.innerHTML = text)
        handleAllAsOne(uniquenessCircle, (circle) => {
            circle.innerHTML = ''
            const bar = new ProgressBar.Circle('#' + circle.id, barOptions)
            bar.animate(percentage)
        })
        handleAllAsOne(sourceLinks, (sourceLink) => {
            if (!urls.length) return handleAllAsOne(sourcesLinksContainer, (element) => element.style.display = 'none')
            else handleAllAsOne(sourcesLinksContainer, (element) => element.style.display = 'block')

            sourceLink.innerHTML = ''
            urls.forEach((url) => {
                const item = createSourceItem(url);
                sourceLink.append(item);
            })
        })

        if (text.length) {
            handleAllAsOne(textLength, element => element.innerHTML = text.length)
            handleAllAsOne(textLengthNoSpaces, element => element.innerHTML = text.replace(/\s+/g, '').length)
            handleAllAsOne(statisticsInfo, (element) => element.style.display = 'block')
            handleAllAsOne(resultControls, (element) => element.style.display = 'flex')
        } else {
            handleAllAsOne(statisticsInfo, (element) => element.style.display = 'none')
            handleAllAsOne(resultControls, (element) => element.style.display = 'none')
        }

        handleAllAsOne(plagiarismContainer, element => {
            element.classList.remove('plagiarism--load')
            element.classList.remove('plagiarism--long-load')
            element.classList.add('plagiarism--result')
        })
    }

    const showFile = (filename) => {
        handleAllAsOne(plagiarismTextField, element => element.style.display = 'none')
        handleAllAsOne(filenameField, element => element.innerHTML = filename);
        handleAllAsOne(plagiarismFileField, element => element.style.display = 'block')
    }

    const showMessage = (type, errorsObject, keepFormOnClose) => {
        var errors = '';
        for (var k in errorsObject) {
            errors = errors + errorsObject[k] + '<br\>';
        }
        handleAllAsOne(messageField, (element) => element.innerHTML = errors)
        handleAllAsOne(messageContainer, (element) => {
            element.classList.add('message-box--' + type)
            element.style.display = 'flex'
        })
        handleAllAsOne(messageClose, (element) => element.dataset.resetForm = !keepFormOnClose)
    }

    const resetError = () => {
        handleAllAsOne(messageField, (element) => element.innerHTML = '')
        handleAllAsOne(messageContainer, (element) => element.style.display = 'none')
    }

    const resetInput = () => {
        handleAllAsOne(fileInput, (element) => element.innerHTML = '')
        handleAllAsOne(filenameField, (element) => element.innerHTML = '');
        file = null
        text = ''
        handleAllAsOne(plagiarismFileField, (element) => element.style.display = 'none')
        handleAllAsOne(plagiarismTextField, (element) => {
            element.style.display = 'block'
            element.value = ''
        })
        handleAllAsOne(checkPlagiarismButton, (element) => element.classList.add('btn--inactive'))
    }

    const resetForm = () => {
        handleAllAsOne(plagiarismContainer, (element) => {
            element.classList.remove('plagiarism--load')
            element.classList.remove('plagiarism--long-load')
            element.classList.remove('plagiarism--result')
            element.classList.remove('submitted')
        })
        resetInput();
    }

    const getFirstSentence = (text) => {
        const pattern = /\d?[\.\!\?]\s/;
        let firstSentence = text.split(pattern)[0];
        if (firstSentence.length > 500) {
            firstSentence =
                firstSentence
                    .slice(0, 500)
                    .split(' ')
                    .slice(0, -1)
                    .join(' ');
        }
        return firstSentence;
    }

    const getTitle = () => {
        if (text.length) return getFirstSentence(text);
        return filename.split('.').slice(0, -1).join('.');
    }

    const stopProgressCheck = () => {
        progressCounter = 0;
        clearInterval(progressCheckerId);
    }

    const sendProgressCheck = async () => {
        if (++progressCounter === TIME_TO_ASK_FOR_EMAIL) showEmailField();

        try {
            const rawData = await fetch(`/plagiarism-checker/result/${checkRequestId}/`, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            const data = await rawData.json()
            if (data['status'] === 'ok') {
                if (data['item']['status'] === 'processed') {
                    const uniqueness = data['item']['uniqueness']
                    const urls = data['item']['urls'] || []
                    stopProgressCheck()
                    resetError()
                    setResult(uniqueness)
                    showResult(uniqueness, urls)
                }
            } else {
                stopProgressCheck();
                showMessage('error', data['errors'])
            }
        } catch (error) {
            stopProgressCheck();
            showMessage('error',['Request error'])
            console.error('Error while requesting /plagiarism-checker/result/: ', error)
        }
    }

    const startProgressCheck = () => {
        progressCheckerId = setInterval(sendProgressCheck, PROGRESS_INTERVAL);
    }

    const showSendResultRequested = () => {
        handleAllAsOne(plagiarismContainer, (element) => element.classList.add('submitted'))
    }

    const sendToCheck = async () => {
        var form = new FormData();
        title = getTitle() || 'Text';
        form.append('text', text);
        form.append('file', file);
        form.append('title', title);

        try {
            const rawData = await fetch('/plagiarism-checker/save/', {
                method: 'post',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                body: form
            })
            const data = await rawData.json()
            const status = data['status'];

            if (status === 'ok' || status === 'error') {
                // error status means work is in the queue of service and processing will take much time
                // (yeah, shitty name for the status)
                checkRequestId = data['id'];
                resetError();
                startProgressCheck();
            } else if (status === 'validation_error') {
                showMessage('error', data['errors']);
            }else {
                showMessage('error',['Oops... Something went wrong.'])
            }
        } catch(error) {
            console.error('Error while /plagiarism-checker/save/: ', error)
        }
    }

    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email)

    const sendEmail = async (event) => {
        if (!email.trim().length) return;
        var currentUrl = getDomain();

        const sendEmailBtn = event.currentTarget;
        const targetForm = sendEmailBtn.closest('form');
        var form = new FormData(targetForm);
        form.set('id', checkRequestId)
        form.set('email', email)
        form.set('type_form', 'sb_plagiarismSaveEmail_1')
        form.set('reg_url', currentUrl)

        try {
            const rawData = await fetch('/plagiarism-checker/saveEmail/', {
                method: 'post',
                body: form,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
            const data = await rawData.json()
            if (data['status'] === 'validation_error') {
                showMessage('error', data['errors'], true);
            } else {
                resetError();
                showSendResultRequested();
            }
        } catch(error) {
            showMessage('error', ['Request error'], true)
            console.error('Error while /plagiarism-checker/saveEmail/: ', error)
        }
    }

    handleAllAsOne(checkPlagiarismButton, disableButton)
    if (!validateEmail(getValueFromOne(emailField))) {
        handleAllAsOne(sendEmailButton, disableButton)
    }

    handleAllAsOne(removeFile, (element) => element.addEventListener('click', resetInput))
    handleAllAsOne(sendEmailButton, (element) => element.addEventListener('click', sendEmail))
    handleAllAsOne(checkAnotherTextButton, (element) => {
        element.addEventListener('click', () => {
            if (progressCounter) stopProgressCheck()
            resetForm()
        })
    })
    handleAllAsOne(messageClose, (element) => {
        element.addEventListener('click', () => {
            if (element.dataset.resetForm) {
                if (progressCounter) stopProgressCheck();
                resetForm();
            }
            resetError();
        })
    })
    handleAllAsOne(uploadFileButton, (element) => {
        element.addEventListener('click', () => {
            handleAllAsOne(fileInput, element => element.click())
        })
    })
    handleAllAsOne(checkPlagiarismButton, (element) => {
        element.addEventListener('click', () => {
            if (!text && !file) return;
            showLoader();
            sendToCheck();
        })
    })
    handleAllAsOne(showTextButton, (element) => {
        element.addEventListener('click', () => {
            handleAllAsOne(dataInfo, (element) => element.classList.remove('active'))
            handleAllAsOne(textInfo, (element) => element.classList.add('active'))
            handleAllAsOne(showResultResultButton, (element) => element.classList.remove('plagiarism-result__nav-item--active'))
            handleAllAsOne(showTextButton, (element) => element.classList.add('plagiarism-result__nav-item--active'))
        })
    })
    handleAllAsOne(showResultResultButton, (element) => {
        element.addEventListener('click', () => {
            handleAllAsOne(dataInfo, (element) => element.classList.add('active'))
            handleAllAsOne(textInfo, (element) => element.classList.remove('active'))
            handleAllAsOne(showResultResultButton, (element) => element.classList.add('plagiarism-result__nav-item--active'))
            handleAllAsOne(showTextButton, (element) => element.classList.remove('plagiarism-result__nav-item--active'))
        })
    })

    lasthopePopupForm.addEventListener('submit', () => {
        lasthopePopupForm.querySelector('input[name="title"]').value = title;
        document.cookie = `pchecker=true; path=/`
        document.cookie = `discountForUserFlag5=true; path=/`
    });

    handleAllAsOne(plagiarismInput, (element) => {
        const resetHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
        }
        const preventEvents = ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop']
        preventEvents.forEach((event) => {
            element.addEventListener(event, resetHandler)
        })

        element.addEventListener('drop', (e) => {
            file = e.originalEvent.dataTransfer.files[0]
            filename = file.name
            showFile(filename)
            handleAllAsOne(checkPlagiarismButton, enableButton)
        })
    })
    handleAllAsOne(fileInput, (element) => {
        element.addEventListener('change', () => {
            file = element.files[0]
            filename = file.name
            showFile(filename)
            handleAllAsOne(checkPlagiarismButton, enableButton)
        })
    })
    handleAllAsOne(plagiarismTextField, element => {
        const events = ['change', 'keyup', 'paste']
        events.forEach((event) => {
            element.addEventListener(event, () => {
                element.scroll({top: 0, behavior: 'smooth'})
                text = element.value
                if (text.trim().length) handleAllAsOne(checkPlagiarismButton, enableButton)
                else handleAllAsOne(checkPlagiarismButton, disableButton)
                // Value in the second form should be the same as in the first one
                handleAllAsOne(plagiarismTextField, (element) => element.value = text)
            })
        })
    })
    handleAllAsOne(emailField, (element) => {
        const events = ['change', 'keyup', 'paste']
        events.forEach((event) => {
            element.addEventListener(event, () => {
                var value = element.value;
                if (!validateEmail(value)) {
                    handleAllAsOne(sendEmailButton, disableButton)
                    email = '';
                } else {
                    handleAllAsOne(sendEmailButton, enableButton)
                    email = value
                }
            })
        })
    })
}

async function checkEmailUniqueness(email) {
    try {
        const rawData = await fetch('/ajax/checkemail', {
            data: {email},
            method: 'post',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        const data = await rawData.json()
        return Number(data.count) === 0
    } catch(error) {
        console.error('Error while /ajax/checkemail/: ', error)
    }

    return true
}

function lasthopePopupLogic() {
    const popup = document.getElementById('popup-lasthope')
    const popupClose = popup.querySelectorAll('[data-lasthope="close"]')

    handleAllAsOne(popupClose, (element) => {
        element.addEventListener('click', () => {
            popup.hidden = true
            document.body.style.overflow = 'revert'
        })
    })

    let shownModal = false

    document.body.addEventListener('mouseleave', (e) => {
        const from = e.relatedTarget || e.toElement
        const sourceElement = e.target.tagName.toLowerCase()
        const uniquenessPercentage = window._uniquenessResultPercents

        const notEnoughPercentage = uniquenessPercentage !== undefined && uniquenessPercentage < 95;
        const needToShow = notEnoughPercentage && !shownModal;

        if (
            (!from || from.nodeName == "HTML") &&
            (sourceElement !== 'input') &&
            needToShow
        ) {
            popup.hidden = false
            document.body.style.overflow = 'hidden'
            shownModal = true
        }
    })
}

function runProgressBar() {
    const limit = parseFloat(document.getElementById('l-1__circle').dataset.value)

    var bar = new ProgressBar.Circle('#l-1__circle', {
        color: '#000',
        strokeWidth: 13,
        trailWidth: 13,
        duration: 15000,
        easing: 'easeInOut',
        text: {
            autoStyleContainer: false
        },
        from: { color: '#ffffff', width: 13 },
        to: { color: '#ffffff', width: 13 },
        step: function(state, circle) {
            circle.path.setAttribute('stroke', state.color);
            circle.path.setAttribute('stroke-width', state.width);

            var value = Math.round(circle.value() * 100);
            if (value === 0) {
                circle.setText('');
            } else {
                circle.setText(value +'%');
            }

        }
    });

    function infiniteBarLoop(up) {
        bar.animate(up ? limit : 0, {}, function() {
            infiniteBarLoop(!up);
        })
    }

    infiniteBarLoop(true);
}

function handleAccordion() {
    initAccordion(document.querySelector('.accordion-list'))
}

init()
